import {
    Directive,
    ElementRef,
    OnInit,
    Output,
    EventEmitter,
    Renderer2
  } from '@angular/core';
  
  @Directive({
    selector: '[appAutoFocusOnClick]',
    standalone: false
})
  export class AutoFocusOnClickDirective implements OnInit {
    @Output() focusOut = new EventEmitter<void>();
    @Output() blurred = new EventEmitter<void>();
  
    constructor(private readonly el: ElementRef<HTMLElement>, private readonly renderer: Renderer2) {}
  
    ngOnInit() {
      const nativeEl = this.el.nativeElement;
  
      // Make the element focusable if it isn't already
      if (!nativeEl.hasAttribute('tabindex')) {
        this.renderer.setAttribute(nativeEl, 'tabindex', '0');
      }
  
      // Click to focus and style
      nativeEl.addEventListener('click', (event: MouseEvent) => {
        const isNodeSelected = (event.currentTarget as HTMLElement).classList.contains('multi-selected-nodes');
        if (isNodeSelected) {
          //node is selected
          nativeEl.focus();
          nativeEl.classList.add('wf-node-focused');
        }
        else {
          //node is deselected
          nativeEl.blur();
        }
      });
  
      // Blur events
      nativeEl.addEventListener('blur', () => {
        this.blurred.emit();
      });
  
      nativeEl.addEventListener('focusout', () => {
        this.focusOut.emit();
      });
    }
  }
  